// extracted by mini-css-extract-plugin
export default {"btn":"BottomSection_btn__3rlZb","wrtnt":"BottomSection_wrtnt__jDLQX"};